import moment from "moment"
import { TFiltrosDetalheFechamento, TFiltrosFormatados } from "../../../../../../../types/api/financeiro/detalhar-fechamentos-conta-corrente";

export function formatarFiltros(filtros: TFiltrosDetalheFechamento): TFiltrosFormatados {
    const filtrosFormatados: TFiltrosFormatados = {
        tipos_publicos: filtros.tipos_publicos,
        codigos_publicos: filtros.codigos_publicos,
        detalhe_publico: filtros.detalhe_publico,
        periodo_apuracao_inicio: moment(filtros.periodo_apuracao.inicio).format('YYYY-MM-DD'),
        periodo_apuracao_fim: moment(filtros.periodo_apuracao.fim).format('YYYY-MM-DD'),
        titulo_receber_emissao_inicio: filtros.titulo_receber_aberto.periodo_emissao_inicio ? moment(filtros.titulo_receber_aberto.periodo_emissao_inicio).format('YYYY-MM-DD') : null,
        titulo_receber_emissao_fim: filtros.titulo_receber_aberto.periodo_emissao_fim ? moment(filtros.titulo_receber_aberto.periodo_emissao_fim).format('YYYY-MM-DD') : null,
        titulo_receber_vencimento_inicio: filtros.titulo_receber_aberto.periodo_vencimento_inicio ? moment(filtros.titulo_receber_aberto.periodo_vencimento_inicio).format('YYYY-MM-DD') : null,
        titulo_receber_vencimento_fim: filtros.titulo_receber_aberto.periodo_vencimento_fim ? moment(filtros.titulo_receber_aberto.periodo_vencimento_fim).format('YYYY-MM-DD') : null,
        titulo_receber_considera_titulos: filtros.titulo_receber_aberto.considera_titulos,
        titulo_pagar_emissao_inicio: filtros.titulo_pagar_aberto.periodo_emissao_inicio ? moment(filtros.titulo_pagar_aberto.periodo_emissao_inicio).format('YYYY-MM-DD') : null,
        titulo_pagar_emissao_fim: filtros.titulo_pagar_aberto.periodo_emissao_fim ? moment(filtros.titulo_pagar_aberto.periodo_emissao_fim).format('YYYY-MM-DD') : null,
        titulo_pagar_vencimento_inicio: filtros.titulo_pagar_aberto.periodo_vencimento_inicio ? moment(filtros.titulo_pagar_aberto.periodo_vencimento_inicio).format('YYYY-MM-DD') : null,
        titulo_pagar_vencimento_fim: filtros.titulo_pagar_aberto.periodo_vencimento_fim ? moment(filtros.titulo_pagar_aberto.periodo_vencimento_fim).format('YYYY-MM-DD') : null,
        titulo_pagar_considera_titulos: filtros.titulo_pagar_aberto.considera_titulos,
        titulo_receber_funcao: filtros.titulo_receber_aberto.funcao,
        titulo_receber_tipo_documento: filtros.titulo_receber_aberto.tipo_documento,
        titulo_receber_situacao: filtros.titulo_receber_aberto.situacao,
        data_fechamento: filtros.data_fechamento ? moment(filtros.data_fechamento, 'YYYY-MM-DD').format('YYYY-MM-DD') : null,
        titulos_pagar_vencimento: filtros.titulos_pagar_vencimento && filtros.titulos_pagar_vencimento.length > 0 ? filtros.titulos_pagar_vencimento.map((item: any) => moment(item, 'YYYY-MM-DD').format('YYYY-MM-DD')) : null,
        titulos_receber_vencimento: filtros.titulos_receber_vencimento && filtros.titulos_receber_vencimento.length > 0 ? filtros.titulos_receber_vencimento.map((item: any) => moment(item, 'YYYY-MM-DD').format('YYYY-MM-DD')) : null,
        nome: filtros.nome,
        numero_lancamento: filtros.numero_lancamento
    }

    return filtrosFormatados;

}

export function desformatarFiltros(filtrosFormatados: TFiltrosFormatados): TFiltrosDetalheFechamento {
    const filtrosDesformatados: TFiltrosDetalheFechamento = {
        tipos_publicos: filtrosFormatados.tipos_publicos,
        codigos_publicos: filtrosFormatados.codigos_publicos,
        detalhe_publico: filtrosFormatados.detalhe_publico,
        periodo_apuracao: {
            inicio: filtrosFormatados.periodo_apuracao_inicio,
            fim: filtrosFormatados.periodo_apuracao_fim
        },
        titulo_receber_aberto: {
            considera_titulos: filtrosFormatados.titulo_receber_considera_titulos ?? null,
            periodo_emissao_inicio: filtrosFormatados.titulo_receber_emissao_inicio ?? null,
            periodo_emissao_fim: filtrosFormatados.titulo_receber_emissao_fim ?? null,
            periodo_vencimento_inicio: filtrosFormatados.titulo_receber_vencimento_inicio ?? null,
            periodo_vencimento_fim: filtrosFormatados.titulo_receber_vencimento_fim ?? null,
            funcao: filtrosFormatados.titulo_receber_funcao ?? null,
            situacao: filtrosFormatados.titulo_receber_situacao ?? null,
            tipo_documento: filtrosFormatados.titulo_receber_tipo_documento ?? null,
        },
        titulo_pagar_aberto: {
            considera_titulos: filtrosFormatados.titulo_pagar_considera_titulos ?? null,
            periodo_emissao_inicio: filtrosFormatados.titulo_pagar_emissao_inicio ?? null,
            periodo_emissao_fim: filtrosFormatados.titulo_pagar_emissao_fim ?? null,
            periodo_vencimento_inicio: filtrosFormatados.titulo_pagar_vencimento_inicio ?? null,
            periodo_vencimento_fim: filtrosFormatados.titulo_pagar_vencimento_fim ?? null,
        },
        data_fechamento: filtrosFormatados.data_fechamento ?? null,
        titulos_pagar_vencimento: filtrosFormatados.titulos_pagar_vencimento ?? [],
        titulos_receber_vencimento: filtrosFormatados.titulos_receber_vencimento ?? [],
        nome: filtrosFormatados.nome,
        numero_lancamento: filtrosFormatados.numero_lancamento
    }

    return filtrosDesformatados
}